import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { resetOnboardProvider, onboardProvider } from "./onboard-provider";

const initialState: ProcessingState = { processing: "idle" };

export const onboardProviderReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(onboardProvider.fulfilled, state => {
    return { ...state, processing: "success" };
  });
  builder.addCase(onboardProvider.pending, state => {
    return { ...state, processing: "pending" };
  });
  builder.addCase(onboardProvider.rejected, state => {
    return { ...state, processing: "failed" };
  });
  builder.addCase(resetOnboardProvider, () => {
    return initialState;
  });
});
